<div mat-dialog-content>
    <kiene-gruppe-anlegen
        [kunde]="input?.kunde"
        [nameVorschlag]="input?.nameVorschlag"
        [einstalldatumAusblenden]="input?.einstalldatumAusblenden"
        [einstalldatum]="input?.einstalldatum"
        [alsDialog]="true"
        (gruppeAngelegt)="setGruppe($event)"
    ></kiene-gruppe-anlegen>
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="close()">Abbrechen</button>
</div>
